import api from "../api.ts";
import axios from 'axios';
import gql from "graphql-tag";
export default {
    methods: {
        async exportExcel(){
            if (!this.$store.state.doctorDitail.id) {
                await this.getMe();
              }
            let queryObj ={
                doctor_id:this.$store.state.doctorDitail.id,
            }
            if (this.searchDate) {
              queryObj.time_start = this.searchStartDate;
              queryObj.time_end = this.searchEndDate;
            }
            if (this.searchPatients) {
              queryObj.patient_name_id=this.searchPatients;
            }
            if (this.searchDoctor){
              queryObj.operation_doctor=this.searchDoctor;              
            }
            if (this.searchOperationName){
              queryObj.operation_name=this.searchOperationName;    
            }
            if (this.searchNote){
              queryObj.note=this.searchNote;
            }
            if (this.searchAmPm){
              queryObj.am_pm=this.searchAmPm;   
            }
            //console.log("In printCosmetRegExcel,queryObj:",queryObj);

            let res = await axios.request({
                method: 'GET',
                url: api.export_cosmet_reg_excel,
                responseType: 'arraybuffer',
                params: queryObj
            });
            this.downloadFile(res.data);  //---调用函数
        },
        async getMe() {
            try {
              let res = await this.$apollo.query({
                query: gql`
                  {
                    me {
                      id
                      realname
                    }
                  }
                `
              });
              let realname = res.data.me.realname;
              this.$store.commit("setMe", realname);
              localStorage.setItem("me", realname);
              this.$store.commit("setdoctorDitail", {
                id: res.data.me.id,
                realname: res.data.me.realname ? res.data.me.realname : ""
              });
            } catch (error) {
              this.$message.error("请检查网络后重试");
            }
          }
    },
}
